module.exports = __webpack_public_path__ + "img/location-dot.2efd378b.svg";